import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import GlobalLoader from 'components/GlobalLoader';
import { ROUTES } from 'enum';
import { selectCustomer } from 'views/CustomersForm/scenario-actions';
import { isAuthenticatedSelector, currentCustomerSelector } from 'store/user/selectors';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { isAuthenticated, currentCustomer, selectCustomer, computedMatch } = rest;

  const { params } = computedMatch;

  useEffect(() => {
    const checkCustomer = async () => {
      if (isAuthenticated && params.cusID) {
        if (!currentCustomer || currentCustomer.uuid !== params.cusID) {
          try {
            setLoading(true);
            await selectCustomer(params.cusID);
          } catch (err) {
            if (err?.response?.status !== 401) {
              history.push(ROUTES.CUSTOMERS);
            }
          } finally {
            setLoading(false);
          }
        }
      }
    };
    checkCustomer();
  }, [currentCustomer, history, isAuthenticated, params.cusID, selectCustomer]);

  if (!isAuthenticated) {
    return <Redirect to={ROUTES.LOGIN} />;
  }

  if ((params.cusID && !currentCustomer?.uuid) || loading) {
    return <GlobalLoader />;
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

ProtectedRoute.propTypes = {
  component: PropTypes.any.isRequired,
  isAuthenticated: PropTypes.bool,
  currentCustomer: PropTypes.object,
};

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticatedSelector(state),
  currentCustomer: currentCustomerSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  selectCustomer: (customer) => dispatch(selectCustomer(customer)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute);
